import { useOutletContext } from 'react-router';

import type { AnalyticsUrlState } from '@/lib/urlState';

type RouteContext = {
  setState: (nextState: Partial<AnalyticsUrlState>) => void;
  state: AnalyticsUrlState;
};

export const useRouteContext = () => useOutletContext<RouteContext>();
